<div class="chat-wrapper">
  <div class="chat-toolbar">
    <a href="https://ad-ui-sandbox.awesome-docs.io/" class="back-btn">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/></svg>
      Back
    </a>
    @if (loading) {
      <span class="loading-text">Loading chat agent...</span>
    }
  </div>
  @if (error) {
    <p class="error">{{ error }}</p>
  }
  <div #chatContainer class="chat-container"></div>
</div>
